export const initializeFonts = () => {

    const links = [
        {
            href: 'https://fonts.googleapis.com',
            rel: 'preconnect'
        },
        {
            href: 'https://fonts.gstatic.com',
            rel: 'preconnect',
            crossorigin: true
        },
        {
            href: 'https://fonts.googleapis.com/css2?family=Mulish:wght@400;600;700&display=swap',
            rel: 'stylesheet'
        },
        {
            href: 'https://fonts.googleapis.com/css?family=Material+Icons%7CMaterial+Icons+Outlined%7CMaterial+Icons+Round',
            rel: 'stylesheet'
        }
    ]

    links.forEach( link => {

        const linkTag = document.querySelector(`link[href="${link.href}"]`);
        if (!linkTag) {
          const fontLink = document.createElement('link');
          fontLink.href = link.href;
          fontLink.rel = link.rel;
          fontLink.crossorigin = link?.crossorigin;
          document.head.appendChild(fontLink);
        }
    })
}

